import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerQnaEdit = () => {
  const [loading, setLoading] = useState(true);
  const [qna, setQna] = useState(null);
  const [answer, setAnswer] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const id = Number(new URLSearchParams(window.location.search).get('id') || 0);

      const res = await axios.get(`/api/seller/qna/edit-data?id=${encodeURIComponent(id)}`, {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setQna(res.data.qna);
        setAnswer(res.data.qna?.answer || '');
      } else {
        alert(res.data?.error || 'Q&A 정보를 불러오지 못했습니다.');
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;
      const error = err?.response?.data?.error;
      if (redirect) {
        window.location.href = redirect;
        return;
      }
      alert(error || 'Q&A 정보를 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        '/api/seller/qna/edit-json',
        {
          id: qna?.id,
          answer,
        },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setMessage(res.data.message || '답변이 등록되었습니다.');
        window.location.href = res.data.redirect || '/seller/qna/list';
        return;
      }

      alert(res.data?.error || '답변 등록에 실패했습니다.');
    } catch (err) {
      alert(err?.response?.data?.error || '답변 등록에 실패했습니다.');
    }
  };

  if (loading) {
    return <div style={styles.loading}>로딩중...</div>;
  }

  if (!qna) {
    return <div style={styles.loading}>데이터가 없습니다.</div>;
  }

  return (
    <SellerLayout shopName="">
      <div style={styles.container}>
        <h2 style={styles.title}>Q&A 답변 작성</h2>

        {message ? <div style={styles.infoAlert}>{message}</div> : null}

        <div style={styles.mb3}>
          <strong>상품명:</strong> {qna.product_name || ''}
        </div>

        <div style={styles.mb3}>
          <strong>작성자:</strong> {qna.nickname || ''}
        </div>

        <div style={styles.mb3}>
          <strong>질문 내용:</strong>
          <div style={styles.questionBox}>
            {qna.is_secret ? (
              '🔒 비밀글'
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: String(qna.question || '').replace(/\n/g, '<br>')
                }}
              />
            )}
          </div>
        </div>

        <div style={styles.mb4}>
          <strong>작성일:</strong> {qna.created_at || ''}
        </div>

        <form onSubmit={handleSubmit}>
          <input type="hidden" name="id" value={qna.id} />

          <div style={styles.mb3}>
            <label htmlFor="answer" style={styles.label}><strong>답변 내용</strong></label>
            <textarea
              id="answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              style={styles.textarea}
              rows={6}
              required
            />
          </div>

          <button type="submit" style={styles.primaryBtn}>답변 등록</button>
          <a href="/seller/qna/list" style={styles.secondaryBtn}>목록으로</a>
        </form>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: { padding: '40px' },
  container: { marginTop: '20px' },
  title: {
    marginBottom: '24px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },
  infoAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    border: '1px solid #b6d4fe',
    background: '#cfe2ff',
    color: '#084298',
    borderRadius: '8px',
  },
  mb3: { marginBottom: '16px' },
  mb4: { marginBottom: '24px' },
  questionBox: {
    marginTop: '8px',
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    borderRadius: '6px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
  },
  textarea: {
    width: '100%',
    minHeight: '160px',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
    resize: 'vertical',
  },
  primaryBtn: {
    display: 'inline-block',
    border: 'none',
    background: '#0d6efd',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    marginRight: '8px',
  },
  secondaryBtn: {
    display: 'inline-block',
    textDecoration: 'none',
    background: '#6c757d',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '6px',
  },
};

export default SellerQnaEdit;